import React from "react";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";

interface StandardFieldsEditorProps {
  formData: Record<string, any>;
  setFormData: React.Dispatch<React.SetStateAction<Record<string, any>>>;
  standardFields: string[];
  readOnlyFields: string[];
}

export default function StandardFieldsEditor({
  formData,
  setFormData,
  standardFields,
  readOnlyFields,
}: StandardFieldsEditorProps) {
  const handleStandardFieldChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    fieldName: string
  ) => {
    const { value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [fieldName]: value,
    }));
  };

  const formatFieldName = (name: string) => {
    return name
      .replace(/\./g, " ")
      .replace(/_/g, " ")
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  const renderStandardField = (key: string, value: any) => {
    if (key === "description") {
      return (
        <div key={key} className="grid grid-cols-4 items-center gap-4">
          <Label htmlFor={key} className="text-right">
            {formatFieldName(key)}
          </Label>
          <Textarea
            id={key}
            value={value || ""}
            onChange={(e) => handleStandardFieldChange(e, key)}
            className="col-span-3 bg-surface-active border-surface-border"
            rows={3}
            disabled={readOnlyFields.includes(key)}
          />
        </div>
      );
    } else {
      return (
        <div key={key} className="grid grid-cols-4 items-center gap-4">
          <Label htmlFor={key} className="text-right">
            {formatFieldName(key)}
          </Label>
          <Input
            id={key}
            value={value || ""}
            onChange={(e) => handleStandardFieldChange(e, key)}
            className="col-span-3 border-none mt-2 bg-surface-active text-white"
            disabled={readOnlyFields.includes(key)}
          />
        </div>
      );
    }
  };

  return (
    <>
      {standardFields.map((field) =>
        renderStandardField(field, formData[field])
      )}
    </>
  );
}
